import gql from 'graphql-tag';
import { useQuery, provideApolloClient } from '@vue/apollo-composable';
import { ref, watch } from 'vue';
import apolloClient from './useApolloClient';
import useDecryptSymbols from './useDecryptSymbols';
import useAlerts from './useAlerts';

const { decryptSymbols } = useDecryptSymbols();
const { addAlert } = useAlerts();

const GET_QUOTE = gql`
  query QuoteQuery($quoteId: ID!) {
    quote(id: $quoteId) {
      QUOTEID
      QUOTENUM
      COMPANYID
      CONTACTID
      ASSIGNEDID
      JOBNAME
      DATEREQUIRED
      VALIDTO
      CREATEDATE
      STATUS
      NOTES
      SHIPVIA
      SHIPLINE1
      SHIPLINE2
      SHIPCITY
      SHIPSTATE
      SHIPPOSTALCODE
      SHIPEMAIL
      SHIPPHONE
      DISCOUNTPCT
      items {
        ITEMID
        QUOTEID
        PRODUCTID
        SORTORDER
        LINETYPE
        DESCRIPTION
        QTY
        UNIT
        UNITPRICE
        DISCOUNTPCT
        PRICELISTID
      }
      company {
        COMPANYID
        NAME
        CMSID
        PRICINGLEVELID
        address {
          LINE1
          LINE2
          CITY
          STATE
          POSTALCODE
          COUNTRYNAME
        }
        phones {
          NUMBERDISPLAY
          TYPEID
        }
      }
      contact {
        CONTACTID
        FIRSTNAME
        LASTNAME
        PRICINGLEVELID
        email {
          ADDRESS
        }
        address {
          LINE1
          LINE2
          CITY
          STATE
          POSTALCODE
          COUNTRYNAME
        }
        phones {
          NUMBERDISPLAY
          TYPEID
          EXT
        }
      }
      salesperson {
        USERID
        DISPLAYNAME
      }
    }
  }
`;

export default function useQuoteQuery() {
  return function getQuote(quoteId) {
    provideApolloClient(apolloClient);

    const quote = ref(null);
    const { result, loading, error, refetch } = useQuery(GET_QUOTE, { quoteId }, { fetchPolicy: 'no-cache' });

    watch(result, () => {
      quote.value = decryptSymbols(result.value?.quote || null);
    });

    watch(error, () => {
      if (error.value) {
        console.error('Error fetching quote:', error.value);
        addAlert('Error fetching quote', 'high', 4);
      }
    });

    return { quote, loading, error, refetch };
  };
}
